const classes = {
        active: 'active',
        loaded: 'loaded'
    },
    selector = {
        base: 'section'
    },
    options = {
        threshold: 0.25
    };

export default function fScrollAnimations() {
    const blocks = document.querySelectorAll(selector.base);
    blocks.forEach((block) => {
        const animEls = block.querySelectorAll('[class*="has-anim-"]');
        if (animEls.length === 0) {
            return;
        }
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animEls.forEach((el) => {
                        el.classList.add(classes.active);
                        el.classList.remove(classes.loaded);
                    });
                    observer.unobserve(block);
                    return;
                }
            });
        }, options);

        animEls.forEach(el => {
            el.classList.add(classes.loaded);
        });

        observer.observe(block);
    });
}
